export default __webpack_public_path__ + "static/media/640_business03-es-web.d4f14864.png";